'use strict';
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var isPrimitive = require('../predicate/isPrimitive.js');
var isTypedArray = require('../predicate/isTypedArray.js');
function clone(obj) {
    if (isPrimitive.isPrimitive(obj)) {
        return obj;
    }
    if (Array.isArray(obj) || isTypedArray.isTypedArray(obj) || obj instanceof ArrayBuffer || typeof SharedArrayBuffer !== 'undefined' && obj instanceof SharedArrayBuffer) {
        return obj.slice(0);
    }
    var prototype = Object.getPrototypeOf(obj);
    var Constructor = prototype.constructor;
    if (obj instanceof Date || obj instanceof Map || obj instanceof Set) {
        return new Constructor(obj);
    }
    if (obj instanceof RegExp) {
        var newRegExp = new Constructor(obj);
        newRegExp.lastIndex = obj.lastIndex;
        return newRegExp;
    }
    if (obj instanceof DataView) {
        return new Constructor(obj.buffer.slice(0));
    }
    if (obj instanceof Error) {
        var newError = new Constructor(obj.message);
        newError.stack = obj.stack;
        newError.name = obj.name;
        newError.cause = obj.cause;
        return newError;
    }
    if (typeof File !== 'undefined' && obj instanceof File) {
        var newFile = new Constructor([
            obj
        ], obj.name, {
            type: obj.type,
            lastModified: obj.lastModified
        });
        return newFile;
    }
    if ((typeof obj === "undefined" ? "undefined" : _type_of(obj)) === 'object') {
        var newObject = Object.create(prototype);
        return Object.assign(newObject, obj);
    }
    return obj;
}
exports.clone = clone;
